// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"index__ExternalLink___3M_qo","ExternalLinkInText":"index__ExternalLinkInText___7b2E_","ExternalLinkButton":"index__ExternalLinkButton___1QT8a"};